import { IRoleTypeService } from "../../service/role/RoleTypeService";
import { IRoleType } from "../../model/role/RoleType";

export default class CreateRoleInteractor {
  private roleTypeService: IRoleTypeService;

  constructor(roleTypeService) {
    this.roleTypeService = roleTypeService;
  }

  async execute(role: IRoleType) {
    return this.roleTypeService.createRoleType(role);
  }
}
